<script>
import datePicker from "@alireza-ab/vue-persian-datepicker";
import { dateFormat, formatDateToEn } from "../../../../Helpers/tools";

// select html tag
const root = document.getElementsByTagName("html")[0];

export default {
  components: {
    datePicker,
  },

  props: {
    type: {
      type: String,
      isRequired: true,
    },

    minDate: {
      type: String,
      isRequired: false,
      default: dateFormat(new Date()),
    },

    title: {
      type: String,
      isRequired: false,
      default: "تاریخ",
    },
  },

  data() {
    return {
      date: "",

      isOpen: false,

      currentLocale: null,

      localeConfigs: {
        fa: {
          weekdays: [
            "شنبه",
            "یک‌شنبه",
            "دوشنبه",
            "سه‌شنبه",
            "چهارشنبه",
            "پنجشنبه",
            "جمعه",
          ],
        },
      },
    };
  },

  computed: {
    todaysDate() {
      let locale = "fa";
      let format = "jD jMMMM";

      if (this.locale === "en,fa") {
        locale = "en";
        format = "d MMMM";
      }

      return dateFormat(new Date(), format, locale);
    },

    formattedDate() {
      return this.date ? dateFormat(this.date) : "";
    },
  },

  methods: {
    goToday() {
      this.$refs.datepicker.goToToday();
    },

    confirm() {
      let datepicker = this.$refs.datepicker;

      datepicker.submitDate();

      if (window.innerWidth < 993) {
        root.classList.remove("no-scroll");
      }

      if (this.type === "entryDate") {
        this.$emit("date-changed", this.date);
        this.$emit("clear-date-diff");
      } else {
        this.$emit("set-date-diff");
      }

      this.$emit("fill-next-input");
    },

    setLocale(locale) {
      this.currentLocale = locale;

      localStorage.setItem("dpf", locale);
    },

    changeLocale(locale) {
      let datepicker = this.$refs.datepicker;

      if (locale !== datepicker.currentLocale) {
        datepicker.changeLocale();

        this.setLocale(datepicker.currentLocale);
      }
    },

    select(date) {
      this.date = formatDateToEn(date.toString(), "YYYY/MM/DD");

      this.confirm();
    },

    open() {
      this.setDefaultLocale();

      let datepicker = this.$refs.datepicker;

      if (this.minDate && !this.date) {
        datepicker.changeSelectedYear(datepicker.fromDate.year());
        datepicker.changeSelectedMonth(datepicker.fromDate.month());
      }

      this.isOpen = true;

      if (this.currentLocale && this.currentLocale !== datepicker.currentLocale)
        datepicker.changeLocale();

      if (window.innerWidth < 993) {
        root.classList.add("no-scroll");
      }
    },

    close() {
      this.isOpen = false;
    },

    closeDatepicker() {
      this.$refs.datepicker.showDatePicker = false;

      if (window.innerWidth < 993) {
        root.classList.remove("no-scroll");
      }
    },

    show() {
      this.$refs.datepicker.showPicker();
    },

    reset() {
      this.$refs.datepicker.clear();
    },

    setDefaultLocale() {
      let datepickerFormat = localStorage.getItem("dpf");

      if (datepickerFormat) {
        this.currentLocale = localStorage.getItem("dpf");
      } else {
        this.currentLocale = "fa";

        localStorage.setItem("dpf", "fa");
      }
    },
  },

  created() {
    this.setDefaultLocale();
  },

  mounted() {
    if (
      window.searchInitialize &&
      window.searchInitialize.search?.checkIn &&
      window.searchInitialize.search?.checkOut
    ) {
      if (this.type === "entryDate") {
        this.date = dateFormat(
          window.searchInitialize.search.checkIn,
          "YYYY-MM-DD"
        );
      } else {
        this.date = dateFormat(
          window.searchInitialize.search.checkOut,
          "YYYY-MM-DD"
        );
      }

      this.$emit("set-date-diff");

    }
  },
};
</script>

<template>
  <div class="booking__item">
    <div class="booking__input" :class="{ 'is-open': isOpen }">
      <label class="booking__input-label">{{ title }}</label>
      <div class="booking__input-header" v-if="!date">
        <i class="icon-date" />
        <span> انتخاب کنید </span>
      </div>

      <span class="booking__input-title fa-num">
        {{ formattedDate }}
      </span>

      <date-picker
        v-model="date"
        locale="fa,en"
        :autoSubmit="false"
        :from="minDate"
        mode="single"
        ref="datepicker"
        :locale-config="localeConfigs"
        :class="{ 'fa-num': currentLocale === 'fa' }"
        @select="select"
        @open="open"
        @close="close"
      >
        <template #icon />

        <template #right-arrow>
          <template v-if="currentLocale === 'fa'">
            <i class="icon-arrow-right ml--1" />

            <span class="hide-in-not-desktop"> ماه قبل </span>
          </template>

          <template v-else>
            <span class="hide-in-not-desktop"> prev month </span>

            <i class="icon-arrow-left mr--1" />
          </template>
        </template>

        <template #left-arrow>
          <template v-if="currentLocale === 'fa'">
            <span class="hide-in-not-desktop"> ماه بعد </span>

            <i class="icon-arrow-left mr--1" />
          </template>

          <template v-else>
            <i class="icon-arrow-right ml--1" />

            <span class="hide-in-not-desktop"> next month </span>
          </template>
        </template>

        <template #footer>
          <div class="pop-header en-num hide-in-desktop">
            <span class="pop-header__title">{{ title }}</span>

            <button
              class="pop-header__btn icon-close"
              @click="closeDatepicker"
            />
          </div>

          <div class="booking__date-header dir-rtl">
            <ul class="booking__locale en-num bold">
              <li
                class="booking__locale-item"
                :class="{ 'is-active': currentLocale === 'fa' }"
                @click="changeLocale('fa')"
              >
                تقویم شمسی
              </li>

              <li
                class="booking__locale-item"
                :class="{ 'is-active': currentLocale === 'en' }"
                @click="changeLocale('en')"
              >
                تقویم میلادی
              </li>
            </ul>

            <button
              class="btn btn--default mr--auto p--0"
              @click="goToday"
              title="برو به امروز"
            >
              برو به امروز
            </button>
          </div>

          <div class="booking__dp-footer">
            <div class="booking__dp-footer-title">
              <span>امروز:</span>

              <span>
                {{ todaysDate }}
              </span>
            </div>

            <button
              class="btn btn--primary en-num"
              @click="confirm"
              title="تائید"
            >
              تائید
            </button>
          </div>
        </template>
      </date-picker>
    </div>
  </div>
</template>
